<script setup>
import VueTagsInput from '@sipec/vue3-tags-input';
import {ref, watch} from "vue";
import {map, pickBy} from "lodash";

const props = defineProps({
  modelValue: {
    type: Array,
    default: [],
  },
  placeholder: {
    type: String,
    default: 'Add a tag',
  },
  autocompleteItems: {
    type: Array,
    default: [],
  },
  addOnlyFromAutocomplete: {
    type: Boolean,
    default: false,
  },
});

const emit = defineEmits(['update:modelValue', 'change', 'tag-changed']);

const tag = ref('');

watch(tag, (currentTag) => {
  if (currentTag.length < 3) {
    return;
  }

  emit('tag-changed', currentTag);
});

const handleTagsChanged = (tags) => {
  const withoutTiClasses = map(tags, (tagValue) => pickBy(tagValue, (value, key) => key !== 'tiClasses'));

  emit('update:modelValue', withoutTiClasses);
  emit('change', withoutTiClasses);
}
</script>

<template>
  <div>
    <vue-tags-input
      v-model="tag"
      :tags="modelValue"
      :model-value="tag"
      :placeholder="placeholder"
      :autocomplete-items="autocompleteItems"
      @tags-changed="handleTagsChanged"
      :add-only-from-autocomplete="addOnlyFromAutocomplete"
    />
  </div>
</template>
